import { useTranslation } from "react-i18next";
import { motion } from "motion/react";
import Image_nl from "@/assets/nl/your-mission-header.png";
import { cx } from "@/lib/style/cva.config";
import { AvatarMe } from "../AvatarMe";

export function YourMissionAvatarWithBackground(props: React.ComponentPropsWithoutRef<"div">) {
	const { i18n, t } = useTranslation();

	return (
		<div
			{...props}
			className={cx("relative h-64 w-full shrink-0 overflow-hidden rounded-xl", props.className)}
		>
			<motion.div
				className="h-full w-full"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 1 }}
			>
				<img
					src={{ nl: Image_nl }[i18n.language]}
					alt={t("your-mission.dashboard.image-alt")}
					className="absolute top-1/2 left-1/2 h-full w-auto -translate-x-1/2 -translate-y-1/2 object-cover"
				/>
				<AvatarMe className="absolute top-1/2 left-1/2 size-24 -translate-x-1/2 -translate-y-1/2" />
			</motion.div>
		</div>
	);
}
